import { render, staticRenderFns } from "./forget.vue?vue&type=template&id=3c59fb32"
import script from "./forget.vue?vue&type=script&lang=js"
export * from "./forget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c59fb32')) {
      api.createRecord('3c59fb32', component.options)
    } else {
      api.reload('3c59fb32', component.options)
    }
    module.hot.accept("./forget.vue?vue&type=template&id=3c59fb32", function () {
      api.rerender('3c59fb32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/forget.vue"
export default component.exports